import React from 'react';
import SegmentComposer from '../outreach/SegmentComposer';
import { LEADS_AUDIENCE } from '../outreach/audiences';

/* Lead-audience wrapper around the shared SegmentComposer.
   Pipeline (and anything else lead-facing) keeps this import path;
   the composer itself is audience-agnostic — see ../outreach/. */

export default function OutreachPanel({ open, onClose, presetStages }) {
  return (
    <SegmentComposer
      open={open}
      onClose={onClose}
      audience={LEADS_AUDIENCE}
      presetFilters={presetStages?.length ? { stages: presetStages } : null}
    />
  );
}
